import * as React from 'react';
import type { MenuData } from "../../js/data/menuData.ts";
import { getEnv } from "../../js/helpers/env.ts";
import MenuItem, { filterMenuItemsByParent } from "./menuItem.tsx";

type Props = {
	menu: MenuData,
	pathname: string,
}

const Footer = ({menu, pathname, ...otherProps}: Props) => {

	const rootMenuItems = filterMenuItemsByParent(menu, null);

	return (<>
		<div id="footerWrapper">
			<footer>
				<div className="flex flex-wrap -mx-10 overflow-hidden items-end">

					<div className="px-12 w-full overflow-hidden lg:w-3/4 mb-8 lg:mb-0">
						<span className="">
							{/*<span className="hidden md:inline">|</span>*/}
							{/*<a href="/contact.html" className="no-underline hover:underline mr-5 md:mx-3">Contact Us</a>*/}
							{/*<span className="hidden md:inline">|</span>*/}
							{/*<a href="/privacy.html" className="no-underline hover:underline mr-5 md:mx-3">Privacy Policy</a>*/}
						</span>
					</div>

					<div className="px-12 w-full lg:w-1/4 overflow-hidden text-left lg:text-right">
						<p className="mb-0 block">&copy; {new Date().getFullYear()} {getEnv('PUBLIC_COMPANY_NAME')?.toString()}</p>
					</div>
				</div>
			</footer>
		</div>

		{/*<div id="cookieWarning">*/}
		{/*	<p>*/}
		{/*		In order to provide you with the best online experience this website uses cookies.*/}
		{/*		By using our website, you agree to our use of cookies.*/}
		{/*	</p>*/}
		{/*	<a id="cookieClose" className="close" href="#close" title="X"><i className="icon-before fa-icon icon-times"></i></a>*/}
		{/*</div>*/}
	</>);
}

export default Footer;
